import { createContext, useState, useEffect, useCallback } from "react";

export const CartContext = createContext();

export const useCart = () => {
  const [cart, setCart] = useState(() => {
    const storedCart = localStorage.getItem("cart");
    return storedCart ? JSON.parse(storedCart) : [];
  });

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  const addToCart = useCallback((product, priceData) => {
    setCart((prevCart) => {
      const existingProduct = prevCart.find(
        (item) =>
          item.uuid === product.uuid &&
          JSON.stringify(item.modifiersList) ===
            JSON.stringify(product.modifiersList)
      );
      if (existingProduct) {
        return prevCart.map((item) =>
          item.uuid === product.uuid &&
          JSON.stringify(item.modifiersList) ===
            JSON.stringify(product.modifiersList)
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      } else {
        return [...prevCart, { ...product, quantity: 1, priceData }];
      }
    });
  }, []);

  const removeFromCart = useCallback((product) => {
    setCart((prevCart) => {
      const productIndex = prevCart.findIndex(
        (item) =>
          item.uuid === product.uuid &&
          item.quantity === product.quantity &&
          JSON.stringify(item.modifiersList) ===
            JSON.stringify(product.modifiersList)
      );

      if (productIndex !== -1) {
        const newCart = [...prevCart];
        newCart.splice(productIndex, 1);
        return newCart;
      }

      return prevCart;
    });
  }, []);

  const incrementQuantity = useCallback((product, priceData) => {
    setCart((prevCart) => {
      const existingProduct = prevCart.find(
        (item) =>
          item.uuid === product.uuid &&
          JSON.stringify(item.modifiersList) ===
            JSON.stringify(product.modifiersList)
      );
      if (existingProduct) {
        return prevCart.map((item) =>
          item.uuid === product.uuid &&
          JSON.stringify(item.modifiersList) ===
            JSON.stringify(product.modifiersList)
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      } else {
        return [...prevCart, { ...product, quantity: 1, priceData }];
      }
    });
  }, []);

  const decrementQuantity = useCallback((product) => {
    setCart((prevCart) => {
      const updatedCart = prevCart.map((item) =>
        item.uuid === product.uuid &&
        JSON.stringify(item.modifiersList) ===
          JSON.stringify(product.modifiersList)
          ? { ...item, quantity: item.quantity - 1 }
          : item
      );
      return updatedCart.filter((item) => item.quantity > 0);
    });
  }, []);

  const emptyCart = useCallback(() => {
    setCart([]);
  }, []);

  const clearCart = () => {
    setCart([]);
  };

  return {
    cart,
    clearCart,
    emptyCart,
    addToCart,
    removeFromCart,
    incrementQuantity,
    decrementQuantity,
  };
};
